export const emptyLegacyCorrection = () => ({
    correctedQuery: '',
    wordCorrections: [],
    originalQuery: '',
});
export const emptyNextCorrection = () => ({
    correctedQuery: '',
    corrections: [],
    originalQuery: '',
});
export function getDidYouMeanInitialState() {
    return {
        enableDidYouMean: false,
        wasCorrectedTo: '',
        wasAutomaticallyCorrected: false,
        queryCorrection: emptyLegacyCorrection(),
        originalQuery: '',
        automaticallyCorrectQuery: true,
        queryCorrectionMode: 'legacy',
    };
}
